import "./Footer.css";

export default function Footer({ name, location }) {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div>{name.toLowerCase()}.sh</div>
      <div>{year} · {location}</div>
    </footer>
  );
}
